export const SupplierDocumentValidation = (formData) => {
    const errors = {};

    if (!formData.Name || !formData.Name.trim()) {
        errors.Name = 'This field is required';
    }

    if (formData.CompanyDocument.toString() === "0") {
        if (!formData.Path || !formData.Path.trim()) {
            errors.Path = 'This field is required';
        }
    }

    

    return errors;
};
